// removed by extract-text-webpack-plugin
module.exports = {"message_popup":"_2O4l6D2L","message_success":"_2lc3nJQo","message_container":"_2Pcbnpzl","message_delete":"_1R_cTrjH","buttons_box":"_21gSPeF2","missingInfo":"_2jnPFAa0","close":"_3JjlZOlE"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/Messages/Messages.styl
// module id = 24
// module chunks = 0